import { Modal } from 'antd';

import type { NDialog } from '@app/components/Dialog/Dialog.types';

export const Dialog: NDialog.Main = ({
  title = 'Уведомление',
  children,
  // description = 'Место для описания.',
  okText = 'Хорошо',
  cancelText = 'Отмена',
  isModalOpen = false,
  footer,
  handleOk,
  handleCancel,
}) => {
  return (
    <Modal
      title={title}
      okText={okText}
      cancelText={cancelText}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={footer}
    >
      {children}
    </Modal>
  );
};
